import { LoadablePaint } from '@confluence/loadable';

export const LazyRouteToRightEditor = LoadablePaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-RouteToRightEditor" */ './RouteToRightEditorComponent'),
});
